import { definePropType } from "@types-vue/props";
import { computed, defineComponent, ref } from "vue";
import PtCustomButton from "@com/components/pt-custom-button/index.vue";
export default defineComponent({
    props: {
        config: {
            type: definePropType(Array),
            required: true
        },
        data: {
            type: definePropType(Object)
        },
        /** 为 true 时忽略存储空间限制，不因存储不足而 disabled（如定制列表） */ ignoreStorageLimit: {
            type: Boolean,
            default: false
        }
    },
    components: {
        PtCustomButton: PtCustomButton
    },
    setup: function setup(props) {
        var effectiveDisabled = function effectiveDisabled(action, storageDisabled) {
            if (props.ignoreStorageLimit) return !!action.disabled;
            return storageDisabled || !!action.disabled;
        };
        var handleCommand = function handleCommand(option) {
            option.onClick && option.onClick(props.data);
        };
        var handleVisibleChange = function handleVisibleChange(visible) {
            active.value = visible;
        };
        var active = ref(false);
        var innerConfig = computed(function() {
            return props.config.filter(function(item) {
                return typeof item.visible === "undefined" || typeof item.visible === "boolean" && item.visible;
            });
        });
        return {
            active: active,
            handleCommand: handleCommand,
            handleVisibleChange: handleVisibleChange,
            innerConfig: innerConfig,
            effectiveDisabled: effectiveDisabled
        };
    }
});
